import * as React from "react";
import { ScrollView } from "react-native";
import { useTheme } from "react-native-paper";
import { Block } from "@block";
import HeaderNav from "app/shared/components/header-nav/header-nav";
import { RouteProp, StackActions, useNavigation, useRoute } from "@react-navigation/native";
import { spacing } from "@styles/spacing";
import { useDesktopMediaQuery } from "@media-query";
import { StackSpacing } from "@components/spacing";
import { useTranslation } from "react-i18next";
import { StepProcessUniversal } from "app/shared/components/stepper-process/stepper-process";
import { NavTitleBar, SubtitleNavTitleBar } from "app/shared/components/nav-title-bar/nav-title-bar";
import { ButtonFormActions, ButtonRow, HeaderSuccessTitle, RowInputColumn } from "app/shared/components/screen-success/screen-success";
import { useDispatch, useSelector } from "react-redux";
import { getPaymentCardStoreSelector } from "../reducer/selectors";
import ScreenNameType from "@navigation/nav-screens";
import { fetchListAccountRequest } from "app/modules/account-management/reducer/actions";
import GlobalViewShot, { GlobalViewShotRef } from "app/shared/components/global-view-shot/global-viewshot.web";
import { formatCurrency } from "app/shared/util/format-currency";
import StackParamsList from "app/navigation/nav-stack-params";

type ProfileScreenRouteProp = RouteProp<StackParamsList, ScreenNameType.PAYMENT_CARD_SUCCESS>;

const PaymentCardSuccess = () => {
  const { colors } = useTheme();
  const { dispatch } = useNavigation();
  const dispatchStore = useDispatch();
  const { t } = useTranslation();
  const isDesktop = useDesktopMediaQuery();
  const globalViewShotRef = React.useRef<GlobalViewShotRef>(null);
  const routeProps = useRoute<ProfileScreenRouteProp>();

  const paymentCardStore = useSelector(getPaymentCardStoreSelector);
  const [preScreen, setPreScreen] = React.useState<string>(t("CARD_DICH_VU_THE"));
  const onPressGoHome = () => {
    dispatch(StackActions.replace(ScreenNameType.HOME));
  };

  const onPressGoBack = () => {
    if (routeProps?.params?.preScreen === ScreenNameType.LIST_PAYMENTS) dispatch(StackActions.replace(ScreenNameType.LIST_PAYMENTS));
    else dispatch(StackActions.replace(ScreenNameType.LIST_CARDS));
  };

  const subtitlesArrays: Array<SubtitleNavTitleBar> = [
    {
      name: t("FUNC_TRANG_CHU"),
      onPressSubtitle: () => onPressGoHome(),
    },
    {
      name: preScreen,
      onPressSubtitle: () => onPressGoBack(),
    },
    {
      name: t("CARD_THANH_TOAN_THE_TIN_DUNG"),
      onPressSubtitle: () => {},
    },
  ];

  const onPressPrint = () => {
    globalViewShotRef.current?.printViewShot();
  };

  const onPressShare = () => {
    globalViewShotRef.current?.takeViewShot();
  };

  const FormSuccess = (
    <Block p={spacing.large}>
      <RowInputColumn name={t("CARD_TAI_KHOAN_THANH_TOAN")} value={paymentCardStore.dataCreate?.ACCOUNT_DEBIT?.ACCOUNTNO} />
      <RowInputColumn name={t("CARD_THANH_TOAN_THE_TIN_DUNG_SO_THE")} value={paymentCardStore.dataCreate?.CARD?.cardNum} />
      <RowInputColumn name={t("CARD_THANH_TOAN_THE_TIN_DUNG_CHU_THE")} value={paymentCardStore.responseCreate?.destinationCardName} />
      <RowInputColumn name={t("CARD_SO_DU_KHA_DUNG")} value={formatCurrency(paymentCardStore.responseAuth?.cardAvalBalance)} />
      <RowInputColumn name={t("COMMON_MA_GD")} value={paymentCardStore.responseConfirm?.requestId} />
      <RowInputColumn name={t("CARD_THANH_TOAN_THE_TIN_DUNG_NOI_DUNG")} value={paymentCardStore.dataCreate?.DESCRIPTION} />
    </Block>
  );

  React.useEffect(() => {
    dispatchStore(fetchListAccountRequest());
  }, [dispatchStore]);

  React.useEffect(() => {
    if (routeProps?.params?.preScreen) {
      const value = routeProps?.params?.preScreen === ScreenNameType.LIST_PAYMENTS ? t("FUNC_DV_THANH_TOAN") : t("CARD_DICH_VU_THE");
      setPreScreen(value);
    }
  }, [routeProps?.params?.preScreen, t]);

  return (
    <Block flex={1} bg={colors.surface}>
      <ScrollView>
        <HeaderNav />
        <NavTitleBar title={t("CARD_THANH_TOAN_THE_TIN_DUNG")} subtitles={subtitlesArrays} />
        <Block pv={spacing.huge} ph={isDesktop ? 150 : 0}>
          <StepProcessUniversal currentSteps={3} />
          <StackSpacing size="medium" />
          <GlobalViewShot ref={globalViewShotRef}>
            <HeaderSuccessTitle amount={paymentCardStore.dataCreate?.AMOUNT} />
            {FormSuccess}
          </GlobalViewShot>
          <ButtonFormActions onPressPrint={onPressPrint} onPressShare={onPressShare} />
          <ButtonRow onPressGoBack={onPressGoBack} onPressGoHome={onPressGoHome} />
        </Block>
      </ScrollView>
    </Block>
  );
};

export default PaymentCardSuccess;
